// extracted by mini-css-extract-plugin
export default {"loading":"productDetail_loading__CcTc9","pcWrap":"productDetail_pcWrap__M1lrz"};